import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { isValidJSON } from '@/utils/validations'

export const externalModelValidation = {
  mixins: [validationMixin],

  computed: {
    errors () {
      const errors = {}
      const { localModel, selectedEngine } = this.$v
      if (localModel.name.$dirty && localModel.name.$invalid && !localModel.name.required) {
        errors.name = this.$t('validations.models-validation.name.required')
      }

      if (selectedEngine.$dirty && !selectedEngine.required) {
        errors.selectedEngine = this.$t('validations.models-validation.engine.required')
      }

      const { settings } = localModel
      if (settings.$invalid) {
        errors.settings = {}
      }

      if (settings.bodyTemplate.$dirty && settings.bodyTemplate.$invalid) {
        errors.settings.bodyTemplate = this.$t('validations.models-validation.bodyTemplate.required')
      }

      return errors
    }
  },

  validations: {
    localModel: {
      name: {
        required
      },
      settings: {
        bodyTemplate: {
          isValidJSON: value => {
            // AWS Comprehend does not have 'bodyTemplate'
            if (value === undefined) {
              return true
            }
            return isValidJSON(value)
          }
        }
      }
    },
    selectedEngine: {
      required
    }
  }
}

export const nluModelSettingsValidation = {
  mixins: [validationMixin],

  computed: {
    errors () {
      const errors = {}
      const { localNluModel } = this.$v
      if (localNluModel.name.$invalid && !localNluModel.name.required) {
        errors.name = this.$t('validations.models-validation.bodyTemplate.name.required')
      }

      return errors
    }
  },

  validations: {
    localNluModel: {
      name: {
        required
      }
    }
  }
}
